import { LatLng } from "@/models/core.model";

export const pathToGeoJson = function(path?: LatLng[]): string {
    if (!path || path.length === 0) return '';
    return JSON.stringify({
        type: 'LineString',
        coordinates: path.map(p => [p.lng, p.lat]),
    });
};

export const getBoundingBoxCenter = function(points: LatLng[]): LatLng|undefined {
    if(points.length == 0){
      return undefined;
    }

    if(points.length == 1){
      return points[0];
    }

    let minLat = points[0].lat,
        maxLat = points[0].lat,
        minLng = points[0].lng,
        maxLng = points[0].lng;

    points.forEach( position => {
      minLat = Math.min(minLat, position.lat);
      maxLat = Math.max(maxLat, position.lat);
      minLng = Math.min(minLng, position.lng);
      maxLng = Math.max(maxLng, position.lng);
    });

    return {
      lat: (minLat + maxLat) / 2,
      lng: (minLng + maxLng) / 2
    };
  };

  export const getPolygonPathsFromGeoJson = function(geoJson: string) {
    try {
      if(!geoJson || geoJson.trim() === '') {
        return [];
      }
      // Parse the GeoJSON string
      const geometry = JSON.parse(geoJson);

      let polygonPaths;

      if (geometry.type === "Polygon") {
        // Single polygon
        polygonPaths = [geometry.coordinates[0].map(([lng, lat]) => ({ lat, lng }))];
      } else if (geometry.type === "MultiPolygon") {
        // Multiple polygons
        polygonPaths = geometry.coordinates.map( polygon =>
            polygon[0].map(([lng, lat]) => ({ lat, lng })) // only outer ring; skip holes
        );
      }

      return polygonPaths;
      
    } catch (error) {
      return [];
    }
  };
  export const getPolylinePathFromGeoJson = function(geoJson: string) {
    try {
      if(!geoJson || geoJson.trim() === '') {
        return [];
      }
      // Parse the GeoJSON string
      const geometry = JSON.parse(geoJson);

      let polygonPaths;

      if (geometry.type === "LineString") {
        // LineString
        polygonPaths = geometry.coordinates.map(([lng, lat]) => ({ lat, lng }));
      } 

      return polygonPaths;
      
    } catch (error) {
      return [];
    }
  };